import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';



export interface OkData {
  title: string;
  message?: string;
  ok?: string;
}

@Component({
  selector: 'app-ok-message',
  templateUrl: './ok-message.component.html',
  styleUrls: ['./ok-message.component.scss'],
  standalone: false
})
export class OkMessageComponent {
  
  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    public dialogRef: MatDialogRef<OkMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OkData
  ) { }
}